import React, { Component } from 'react';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import AuthTop from 'components/AuthTop';
import AuthWrapper from 'components/AuthWrapper';
import SupportButton from 'components/SupportButton';
import { CV_WEB_NEW_ONBOARD_EXP_ENABLED } from 'utils/constants';
import { QUERY_GET_REMOTE_CONFIG_ENTRY } from 'utils/hook/query/useRemoteConfigEntry';
import { enableIntroTour, enableOnboardTour } from 'utils/localStorage';
import imageSuccess from 'resources/Image-Success.png';
import './VerifyNewUser.css';

class VerifyNewUserPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      success: undefined
    };
  }

  componentDidMount() {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.token
    ) {
      const token = this.props.match.params.token;

      this.props
        .verifyToken(token)
        .then(({ data }) => {
          const res = data && data.verifyNewUser && data.verifyNewUser.success;
          if (res) {
            if (this.props.newOnboardEnabledData?.remoteConfigEntry?.value) {
              enableOnboardTour();
            } else {
              enableIntroTour();
            }
          }
          this.setState({ success: res });
        })
        .catch(() => {
          this.setState({ success: false });
        });
    }
  }

  render() {
    const success = this.state.success;
    return (
      <div className="expand-wrap">
        <Helmet>
          <title>Email Verification</title>
        </Helmet>
        <div className="verify-new-user-page">
          <AuthWrapper aria-label="Verify Email Form" logoName="signup">
            <AuthTop hideLogo>
              <h1 className="sr-only">Email Verification</h1>
              {success === undefined && 'Verifying...'}
              {success === true && (
                <div className="success-msg-container">
                  <div className="verify-success-image">
                    <img src={imageSuccess} alt="" />
                  </div>
                  <div className="success-text">Success!</div>
                  <div className="success-sub-text">
                    Your Wind Creek account has been verified, and you can now
                    Sign In.
                  </div>
                </div>
              )}
              {success === false && (
                <div className="error-sub-text">
                  The server was not able to process your request. Your account
                  may already be verified, or this verification link may be
                  invalid. If you are not able to log into your account, please
                  contact Support.
                </div>
              )}
              <Link to="/login" className="btn button-color-green btn-block">
                Sign In
              </Link>
            </AuthTop>
            <SupportButton />
          </AuthWrapper>
        </div>
      </div>
    );
  }
}

const VERIFY_NEW_USER_MUTATION = gql`
  mutation MyVerifyNewUser($token: String!) {
    verifyNewUser(token: $token) {
      success
      message
    }
  }
`;

const REMOTE_CONFIG_EVENT = gql`
  subscription remoteConfigEvent {
    remoteConfigEvent {
      action
      entries {
        key
        value
      }
    }
  }
`;

export default compose(
  graphql(VERIFY_NEW_USER_MUTATION, {
    props: ({ ownProps, mutate }) => ({
      verifyToken: token => mutate({ variables: { token } })
    })
  }),
  graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
    name: 'newOnboardEnabledData',
    options: {
      variables: {
        key: CV_WEB_NEW_ONBOARD_EXP_ENABLED
      },
      fetchPolicy: 'cache-and-network'
    },
    props: ({ ownProps, newOnboardEnabledData }) => {
      return {
        newOnboardEnabledData,
        subscribeToNewData: () => {
          return newOnboardEnabledData.subscribeToMore({
            document: REMOTE_CONFIG_EVENT,
            updateQuery: (prev, { subscriptionData }) => {
              if (subscriptionData?.data?.action === 'Update') {
                subscriptionData?.data?.entries.forEach(({ key, value }) => {
                  if (key === CV_WEB_NEW_ONBOARD_EXP_ENABLED) {
                    prev.remoteConfigEntry.value = value;
                  }
                });
              }
              return prev;
            }
          });
        }
      };
    }
  })
)(VerifyNewUserPage);
